module.exports = __webpack_public_path__ + "static/media/No_rating.2dbeeecb.svg";